import  AdminPanel  from "../pages/adminPanel";
import ScreenInfo from "../pages/adminPanel/PublicScreens/components/ScreenInfo";
import ScreenDetails from "../pages/adminPanel/Screens/ScreenDetails";
import {LoginPage} from "../pages/auth/login/Login";
import { routes } from "./routes";

export type TRouteData = {
    path: string;
    Component: React.FC<any>;
    isPrivate: boolean;
    navigationMenu?: boolean;
    children?: {
        path: string;
        Component: React.FC<any>;
    }[]
}


export const routesData: TRouteData[] = [
    { path: routes.login, Component: LoginPage, isPrivate: false, navigationMenu: true },
    { path: routes.home, Component: LoginPage, isPrivate: false, navigationMenu: true },
    { path: routes.admin, Component: AdminPanel, isPrivate: true, navigationMenu: true },
    { path: routes.screenId, Component: ScreenInfo, isPrivate: true, navigationMenu: false },
]
